import UserRole from '../type/enum/UserRole';


/**
 * Determines whether a given role is allowed to log in.
 * Prevents ROLE_CLIENT from logging in.
 */
export const isValidRoleForLogin = (role?: UserRole): boolean => {
    return role !== UserRole.ROLE_CLIENT && role !== UserRole.ROLE_OPERATOR;
};